import React, { useState, useEffect } from 'react'
import { Global } from '@emotion/react'
import { styled } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'

import * as Styled from './styles'

import { APP_HEADER_FIXED_HEIGHT } from '../AppHeader/styles'

const Root = styled('div')(() => ({
  height: '100%',
}))

const StyledBox = styled('div')(() => ({}))

interface Props {
  children?: React.ReactNode
  open: boolean
  onClose: () => void
  onOpen: () => void
}

const SwipeableEdgeDrawer: React.FC<Props> = ({ children, open, onClose, onOpen }) => {
  const [drawerBleeding, setDrawerBleeding] = useState(window.innerWidth < 768 ? 160 : 190)

  useEffect(() => {
    const handleResize = (): void => {
      setDrawerBleeding(window.innerWidth < 768 ? 160 : 190)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Root>
      <CssBaseline />
      <Global
      // @ts-expect-error // TODO
        styles={{
          '.MuiDrawer-root': {
            position: 'static !important',
          },
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(100vh - 80px - ${APP_HEADER_FIXED_HEIGHT} -  ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />
      <SwipeableDrawer
        container={window.document.body}
        anchor="bottom"
        open={open}
        onClose={onClose}
        onOpen={onOpen}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        allowSwipeInChildren={false} // needs to be false so that user can interact with the model
        ModalProps={{
          keepMounted: true,
        }}
      >
        <StyledBox
          className={open ? 'MuiDrawer-open' : ''}
          // For refrence see this link https://mui.com/system/getting-started/the-sx-prop/
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            visibility: 'visible',
            right: 0,
            left: 0,
            backgroundColor: 'transparent',
          }}
        >
          {children}
          <Styled.Puller />
        </StyledBox>
      </SwipeableDrawer>
    </Root>
  )
}

export default SwipeableEdgeDrawer
